import { useEffect } from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import FAQ from "../components/FAQ";
import HowGateway from "../components/HowGateway";

const Home = () => {
  useEffect(() => {
    if (window.jQuery && window.$ !== undefined) {
      const $ = window.jQuery;

      if ($.fn.owlCarousel) {
        $("#owl-testimonial").owlCarousel({
          items: 3,
          loop: true,
          nav: false,
          margin: 30,
          dots: true,
          autoplay: true,
          autoplayTimeout: 2000,
          autoplayHoverPause: true,
          responsive: {
            0: { items: 1 },
            600: { items: 2 },
            1000: { items: 3 },
          },
        });
      }

      if ($.fn.tab) {
        $(".tab1").tab();
        $(".tab2").tab({ trigger_event_type: "mouseover" });
      }
    }

    if (window.initCounterAnimation) {
      window.initCounterAnimation();
    }
  }, []);

  return (
    <div>
      <SEO
        title="Trusted Multi Strategy Investment Advisor"
        description="Expert financial advisory, mutual funds, and trading solutions for long-term wealth creation. Gateway Financial Services Limited is India's most trusted multi strategy investment advisor."
      />

      <section className="service-banner" id="home-main-banner">
        <img
          src="/images/banners/home-banner.avif"
          alt="Home Banner"
          loading="lazy"
          id="service-desktop-banner"
        />
        <img
          src="/images/banners/home-mobile-banner.avif"
          alt="Home Mobile Banner"
          loading="lazy"
          id="service-mobile-banner"
        />
        <div className="services-banner-content">
          <h1
            className="text-center px-5"
            data-aos="fade-up"
            id="home-banner-title"
            style={{ lineHeight: "1.05" }}
          >
            Smarter investing with trusted research, seamless trading, and a
            Gateway to <br /> long-term wealth creation.
          </h1>
          <div className="banner-highlights">
            <span data-aos="fade">
              Investing with Gateway Financial Services Limited
            </span>
          </div>
        </div>
      </section>

      <section id="welcome-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
              <h2 data-aos="fade-up">
                India’s most trusted multi strategy investment advisor
              </h2>
              <p className="spc-txt">
                We have seen 5 Market crashes, 5 rate cycles, and 5000+ client
                portfolios
              </p>
            </div>
          </div>
          <div className="row mt-lg-5">
            <div className="col-lg-4">
              <div className="wel-box text-center">
                <div className="wel-box-img">
                  <img
                    src="/images/icons/home/1.png"
                    className="img-fluid"
                    alt="Years of Experience"
                  />
                </div>
                <div className="wel-box-ctn counter-box">
                  <span className="num" data-val={30}>
                    30
                  </span>
                  <span>+</span>
                  <p>Years Experience</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="wel-box text-center">
                <div className="wel-box-img">
                  <img
                    src="/images/icons/home/2.png"
                    className="img-fluid"
                    alt="AUM"
                  />
                </div>
                <div className="wel-box-ctn counter-box">
                  <span className="num" data-val={1000}>
                    1000
                  </span>
                  <span>+</span>
                  <p>cr AUM </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="wel-box text-center">
                <div className="wel-box-img">
                  <img
                    src="/images/icons/home/3.png"
                    className="img-fluid"
                    alt="Registered Clients"
                  />
                </div>
                <div className="wel-box-ctn counter-box">
                  <span className="num" data-val={2000}>
                    2000
                  </span>
                  <span>+</span>
                  <p>Clients</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="service-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-7 text-center mb-3">
              <h3 data-aos="fade-up">Your Goals, Our Services</h3>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4">
              <div className="serv-box text-center hserv_minhight">
                <img
                  src="/images/icons/home/gs-1.png"
                  className="img-fluid"
                  alt="Mutual Funds Service"
                />
                <h4>Mutual Funds</h4>
                <p>
                  Build long-term wealth through expertly curated mutual fund
                  solutions aligned to your goals.
                </p>
                <Link to="/mutual-funds" className="lm-btn">
                  Learn More
                </Link>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="serv-box text-center hserv_minhight">
                <img
                  src="/images/icons/home/gs-2.png"
                  className="img-fluid"
                  alt="Equity Trading"
                />
                <h4>Equity &amp; Commodity Trading</h4>
                <p>
                  Trade equities and commodities with robust platforms,
                  real-time insights, and disciplined execution.
                </p>
                <Link to="/equity-commodity-trading" className="lm-btn">
                  Learn More
                </Link>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="serv-box text-center hserv_minhight">
                <img
                  src="/images/icons/home/gs-3.png"
                  className="img-fluid"
                  alt="Depository Services"
                />
                <h4>Depository Services</h4>
                <p>
                  Secure, seamless demat services ensuring safe custody and
                  smooth settlement of your investments.
                </p>
                <Link to="/depository-services" className="lm-btn">
                  Learn More
                </Link>
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-lg-4">
              <div className="serv-box text-center hserv_minhight">
                <img
                  src="/images/icons/home/gs-4.png"
                  className="img-fluid"
                  alt="Global Investments"
                />
                <h4>Global Investments</h4>
                <p>
                  Diversify beyond borders with access to global markets and
                  international investment opportunities.
                </p>
                <Link to="/global-investments" className="lm-btn">
                  Learn More
                </Link>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="serv-box text-center hserv_minhight">
                <img
                  src="/images/icons/home/gs-5.png"
                  className="img-fluid"
                  alt="Fixed Income Products"
                />
                <h4>Fixed Income Products</h4>
                <p>
                  Preserve capital and earn stable returns with a range of
                  reliable fixed-income instruments.
                </p>
                <Link to="/fixed-income-products" className="lm-btn">
                  Learn More
                </Link>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="serv-box text-center hserv_minhight">
                <img
                  src="/images/icons/home/gs-6.png"
                  className="img-fluid"
                  alt="Insurance Products"
                />
                <h4>Insurance Products</h4>
                <p>
                  Protect your wealth and future with comprehensive insurance
                  solutions tailored to your needs.
                </p>
                <Link to="/insurance-products" className="lm-btn">
                  Learn More
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <HowGateway />

      <section id="testimonial-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 text-center mb-4">
              <h3 data-aos="fade-up">What Our Clients Say About Us</h3>
            </div>

            <div className="col-lg-12">
              <div id="demo-pranab">
                <div id="owl-testimonial" className="owl-carousel owl-theme">
                  <div className="item">
                    <div className="testimonial-box">
                      <i className="fa fa-quote-left" aria-hidden="true" />
                      <p>
                        The research quality and timely market insights have
                        helped me make confident investment decisions. Their
                        team is responsive and professional.
                      </p>
                      <h5 className="mb-0">Rohit Mehta</h5>
                      <p className="mb-0 c_Desc">Business Owner</p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="testimonial-box">
                      <i className="fa fa-quote-left" aria-hidden="true" />
                      <p>
                        A reliable platform with smooth execution and
                        transparent pricing. I especially appreciate the
                        disciplined approach to risk management.
                      </p>
                      <h5 className="mb-0">Ankit Sharma</h5>
                      <p className="mb-0 c_Desc">Retail Investor</p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="testimonial-box">
                      <i className="fa fa-quote-left" aria-hidden="true" />
                      <p>
                        Gateway’s advisory services are well-structured and
                        aligned with long-term wealth creation. I’ve seen
                        consistency in their recommendations.
                      </p>
                      <h5 className="mb-0">Neha Agarwal</h5>
                      <p className="mb-0 c_Desc">Chartered Accountant</p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="testimonial-box">
                      <i className="fa fa-quote-left" aria-hidden="true" />
                      <p>
                        The trading experience is seamless, backed by strong
                        customer support. Their equity and derivatives research
                        stands out.
                      </p>
                      <h5 className="mb-0">Suresh Iyer</h5>
                      <p className="mb-0 c_Desc">Senior Professional</p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="testimonial-box">
                      <i className="fa fa-quote-left" aria-hidden="true" />
                      <p>
                        What I value most is the clarity in communication and
                        detailed reports. It has helped me understand markets
                        better.”
                      </p>
                      <h5 className="mb-0">Pooja Kulkarni</h5>
                      <p className="mb-0 c_Desc">Salaried Investor</p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="testimonial-box">
                      <i className="fa fa-quote-left" aria-hidden="true" />
                      <p>
                        From onboarding to portfolio reviews, the experience has
                        been smooth and transparent. A dependable partner for
                        serious investors.
                      </p>
                      <h5 className="mb-0">Vikram Patel</h5>
                      <p className="mb-0 c_Desc">HNI Client</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <FAQ />

      <section id="app-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 align-self-center">
              <h3 data-aos="fade">Download our Investment Fund App</h3>
              <p>Investing With Gateway Financial Services Limited</p>
              <a href="#download" className="lm-btn">
                Download &amp; Explore More
              </a>
            </div>
            <div className="col-lg-6">
              <img
                src="/images/download.avif"
                className="img-fluid"
                alt="Download App Preview"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
